import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import * as $ from 'jquery';

@Directive({
  selector: '[capitalizeButton]'
})
export class CapitalizeButtonDirective implements AfterViewInit {

  constructor(private element : ElementRef) { 

    // element.nativeElement.style.setProperty('text-transform','capitalize', 'important');
   // element.nativeElement.style.setProperty('font-size','14px', 'important');

    //element.nativeElement.name= element.nativeElement.name.charAt(0).toUpperCase() + element.nativeElement.name.slice(1);
    //console.log((element.nativeElement as HTMLButtonElement).name)
  }
  ngAfterViewInit(): void {
    // let value1= $(this.element.nativeElement);
    // let value = $(this.element.nativeElement).html();
    // console.log(value)
   
  }

}
